import t from "@/lang/lang";
import {
  CommonDialogFooter,
  CommonDialogHeader,
  CommonDialogTrigger,
} from "@/shared/components/dialog/dialog-common";
import { Dialog, DialogContent } from "@/shared/components/ui/dialog";
import { UUID } from "@bitory-gmbh/nidavellir";
import { AlertTriangle, Trash2 } from "lucide-react";
import { useProcessesProcessDeleteMutation } from "../api/process-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useState } from "react";
import { toast } from "sonner";
import { useNumbersProcessNumberShowQuery } from "../../numbers/api/process-number-api";
import { Input } from "@/shared/components/ui/input";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@/shared/components/ui/alert";

export function DeleteProcessDialog({
  processId,
  onSuccess,
}: {
  processId: UUID;
  onSuccess: () => void;
}) {
  const [open, setOpen] = useState(false);
  const [del, { isLoading, error }] = useProcessesProcessDeleteMutation();

  // The user must type in the process number to delete the process.
  const { data: number } = useNumbersProcessNumberShowQuery({ processId });
  const [confirmation, setConfirmation] = useState("");

  const deleteConfirmed = confirmation === number?.string;

  const doDelete = () => {
    if (!deleteConfirmed) return;
    if (isLoading) return;

    del({ id: processId })
      .unwrap()
      .then(() => {
        setOpen(false);
        onSuccess?.();
        toast.success(t("Vorgang gelöscht."));
      });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <CommonDialogTrigger icon={Trash2} label={""} variant="outline" />
      <DialogContent>
        <CommonDialogHeader title={t("Vorgang löschen")} />
        <Alert>
          <AlertTriangle />
          <AlertTitle>{t("Warnung")}</AlertTitle>
          <AlertDescription>
            {t(
              "Das Löschen eines Vorgangs kann nicht wiederrufen werden. Dokumente welche mit dem Vorgang verknüpft wurden, können über den Vorgang nicht mehr gefunden werden.",
            )}
          </AlertDescription>
        </Alert>
        <Input
          value={confirmation}
          onChange={(e) => setConfirmation(e.target.value)}
          placeholder={t("Vorgangsnummer zur Bestätigung eingeben")}
        />
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter
          disabled={!deleteConfirmed}
          isLoading={false}
          onClickAction={doDelete}
          destructive
        />
      </DialogContent>
    </Dialog>
  );
}
